import React from "react";
import Loader from "../../Loader";
import vehicle_types from "../../../constants/vehicle_types";
import colors from "../../../constants/colors";
import { formStyles } from "../formStyles";

export default function VehicleSpecsStep(props) {
  const { register, errors, handleChange, handleSubmit, nextStep, prevStep, manufacturers, models, years, states, inputs, isLoading } = props;

  return (
    <div className={formStyles.card}>
      <h2 className={formStyles.header}>Vehicle Specifications</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div>
          <label className={formStyles.label}>Licence Plate Number</label>
          <input type="text" {...register("license_plate", { required: true })} className={`${formStyles.input} uppercase tracking-widest font-mono`} placeholder="XYZ123AA" />
          {errors.license_plate && <p className="text-sm text-red-500 mt-1">Required</p>}
        </div>
        <div className="md:col-span-2">
          <label className={formStyles.label}>VIN/Chassis Number</label>
          <input type="text" {...register("chassis_number", { required: true, minLength: 17, maxLength: 17 })} className={`${formStyles.input} uppercase tracking-widest font-mono`} placeholder="17 Digit VIN" />
          {errors.chassis_number && <p className="text-sm text-red-500 mt-1">Must be exactly 17 characters</p>}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div>
          <label className={formStyles.label}>Make (Manufacturer)</label>
          <select {...register("manufacturer", { required: true })} onChange={handleChange} className={formStyles.input}>
            <option value="">Select Make</option>
            {manufacturers.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
        </div>
        <div>
          <label className={formStyles.label}>Model</label>
          <select {...register("model", { required: true })} className={formStyles.input}>
            <option value="">Select Model</option>
            {models.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
        </div>
        <div>
          <label className={formStyles.label}>Engine Number</label>
          <input type="text" {...register("engine_number", { required: true })} className={formStyles.input} />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div>
          <label className={formStyles.label}>Vehicle Type</label>
          <select {...register("vehicle_type", { required: true })} className={formStyles.input}>
            <option value="">Select Type</option>
            {vehicle_types.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
        </div>
        <div>
          <label className={formStyles.label}>Year of Manufacture</label>
          <select {...register("year", { required: true })} className={formStyles.input}>
            <option value="">Select Year</option>
            {years.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
        </div>
        <div>
          <label className={formStyles.label}>Color</label>
          <select {...register("color", { required: true })} onChange={handleChange} className={formStyles.input}>
            <option value="">Select Color</option>
            {colors.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <label className={formStyles.label}>Vehicle Usage</label>
          <select {...register("vehicle_usage", { required: true })} className={formStyles.input}>
            <option value="">Select Usage</option>
            <option value="Private">Private</option>
            <option value="Commercial">Commercial</option>
            <option value="Government">Government</option>
          </select>
        </div>
        <div>
          <label className={formStyles.label}>Source of Vehicle</label>
          <select {...register("source_of_vehicle", { required: true })} className={formStyles.input}>
            <option value="">Select Source</option>
            <option value="Imported">Imported</option>
            <option value="Locally Assembled">Locally Assembled</option>
          </select>
        </div>
        <div>
          <label className={formStyles.label}>MVLA State</label>
          <select {...register("mla", { required: true })} onChange={handleChange} className={formStyles.input}>
            <option value="">Select State</option>
            {states.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
          {inputs.mla && <input type="hidden" value={`${inputs.mla} State, Nigeria`} {...register("mla_address")} />}
        </div>
      </div>

      <div className="flex justify-between items-center mt-10 pt-6 border-t border-gray-200">
        <button type="button" onClick={prevStep} className={formStyles.buttonSecondary}>&laquo; Previous</button>
        <button type="button" onClick={handleSubmit(nextStep)} className={formStyles.buttonPrimary}>
          Next &raquo; {isLoading && <span className="ml-2"><Loader /></span>}
        </button>
      </div>
    </div>
  );
}